import { render, staticRenderFns } from "./DeclareHistoryDialog.vue?vue&type=template&id=79aa2368&scoped=true"
import script from "./DeclareHistoryDialog.vue?vue&type=script&lang=js"
export * from "./DeclareHistoryDialog.vue?vue&type=script&lang=js"
import style0 from "./DeclareHistoryDialog.vue?vue&type=style&index=0&id=79aa2368&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79aa2368",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Karl\\Code\\customs_clearance\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79aa2368')) {
      api.createRecord('79aa2368', component.options)
    } else {
      api.reload('79aa2368', component.options)
    }
    module.hot.accept("./DeclareHistoryDialog.vue?vue&type=template&id=79aa2368&scoped=true", function () {
      api.rerender('79aa2368', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Importer/components/DeclareHistoryDialog.vue"
export default component.exports